import { NgxMaskModule, IConfig } from 'ngx-mask';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SettingsRoutingModule } from './settings-routing.module';
import { SettingsService } from './settings.service';

import { ChangePasswordComponent } from './change-password/change-password.component';
import { HomeComponent } from './home/home.component';
import { SharedTranslateLazyModule } from '../shared/shared-translate-lazy.module';
import { CommonUtilityModule } from '../shared/common-utility.module';
import { ReactiveFormsModule } from '@angular/forms';
import { LeftMenuModule } from '../shared/left-menu.module';
import { MailingAddressComponent } from './mailing-address/mailing-address.component';

const maskConfig: Partial<IConfig> = {
  validation: false,
};

@NgModule({
  declarations: [HomeComponent, MailingAddressComponent, ChangePasswordComponent],
  imports: [NgxMaskModule.forRoot(maskConfig),
    CommonModule,
    SettingsRoutingModule,
    SharedTranslateLazyModule,CommonUtilityModule,ReactiveFormsModule,LeftMenuModule
  ],
  providers:[SettingsService]

})
export class SettingsModule { }
